// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/FormattedGB.scss
// module id = 1307
// module chunks = 0